module.exports = __webpack_public_path__ + "media/application/images/2018/email-blue-207b48787b57605bc0441518fbf3bfd0.svg";